export default __webpack_public_path__ + "static/media/folder.664abd5a.svg";